export default __webpack_public_path__ + "static/media/faq_2_img_2.89995697.svg";